import { useFocusProductStore } from "@/stores/useFoucsProductStore";
import ReactPlayer from 'react-player/youtube';
import { MamapediaHomepageProps, VideoItemProps } from "./constants";
import MainBanner from "./MainBanner";
import TabCategorizedArticle from "./TabCategorizedArticle";
import { useEffect, useRef, useState } from "react";
import { getFocusProducts } from "@/lib/Definitions";
import SlideFocusProduct from "../Product/SlideFocusProduct";
import Image from 'next/image';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import Cookies from "js-cookie";
import HorizontalProduct from "../Product/HorizontalProduct";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import MamapediaVideoList from "./MamapediaVideoList";
import ShopAtMOOIMOM from "../Common/ShopAtMOOIMOM";


export interface VideoProps extends VideoItemProps {
  video_id: string;
}

interface MamapediaHomepageItemProps {
  homepage: MamapediaHomepageProps
}

const MamapediaHome = (props: MamapediaHomepageItemProps) => {
  const { homepage } = props
  const viewport = Cookies.get('viewport');
  const focusProductData = useFocusProductStore(state => state.focusProduct);
  const updateFocusProduct = useFocusProductStore(state => state.updateFocusProduct);
  const [videos, setVideos] = useState<Array<VideoProps>>([]);
  const [video, setVideo] = useState<string | null>(null);
  const [videoHeight, setVideoHeight] = useState(0);
  const videoRef = useRef<HTMLDivElement>(null);
  const isSyncingRef = useRef(false);

  useEffect(() => {
    if (videoRef.current !== null) {
      setVideoHeight(videoRef.current.offsetWidth * 0.5625);
    }
  }, [videos])

  useEffect(() => {
    if (homepage.video_list.length > 0) {
      const videoList = homepage.video_list.map((video, index) => {
        const video_id = video.video_link.split('/').pop();
        return {
          ...video,
          video_id: video_id || video.video_link
        }
      })

      setVideos(videoList);
      setVideo(videoList[0].video_id);
    }
  }, [homepage])

  useEffect(() => {
    if ((focusProductData.data.length === undefined || focusProductData.data.length === 0 || focusProductData.update_date === null || focusProductData.update_date < Date.now() - 3600000) && !isSyncingRef.current) {
      isSyncingRef.current = true;
      getFocusProducts()
        .then((response) => {
          const data = {
            update_date: Date.now(),
            data: response
          }

          updateFocusProduct(data);
        }).finally(() => {
          isSyncingRef.current = false;
        })
    }
  }, [focusProductData, updateFocusProduct])

  return (
    <>
      <div className={`grid grid-cols-1 md:grid-cols-3 gap-x-8 font-poppins mt-0 md:mt-12 ${viewport === "desktop" ? "container" : ""}`}>
        <div className="col-span-1 md:col-span-2">
          <MainBanner banners={homepage.main} />
          <TabCategorizedArticle latest={homepage.latest} hot={homepage.hot} viewport={viewport || "mobile"} />
          {focusProductData.data.length > 0 && (
            <div className={`bg-topTextBg py-4 container my-6 md:hidden`}>
              <SlideFocusProduct title="Trending Produk" link="/" link_name="Shop at MOOIMOM" products={focusProductData.data} />
            </div>
          )}
          <div className={`${viewport === "desktop" ? "" : "container"} flex items-center justify-between mb-6 font-poppins`}>
            <h3 className="text-base text-black font-bold">Read by Categories</h3>
          </div>
          <TabCategorizedArticle
            Kehamilan={homepage.Kehamilan}
            Menyusui={homepage.Menyusui}
            Parenting={homepage.Parenting}
            Anak={homepage["Tumbuh Kembang Anak"]}
            viewport={viewport || "mobile"}
          />
          {videos.length > 0 && (
            <div className={`container mb-12 video-section bg-topTextBg py-6 font-poppins md:hidden`}>
              <h3 className="text-base text-black font-bold mb-4">MOOIMOM Channel</h3>
              <div ref={videoRef}>
                <ReactPlayer
                  url={`https://www.youtube.com/watch?v=${video}`}
                  width="100%"
                  height={videoHeight}
                  playing={false}
                  loop={true}
                  controls={true}
                  muted={true}
                />
              </div>
              <hr className="my-4 bg-reviewBg" />
              <h5 className="text-sm text-black font-semibold mb-4">Video Lainnya</h5>
              <Swiper
                spaceBetween={16}
                centeredSlides={false}
                loop={true}
                slidesPerView={2.2}
                pagination={{
                  clickable: true,
                  enabled: true,
                }}
                modules={[Pagination]}
                className="mamapedia-video-list !pb-5"
              >
                {videos.map((video, index) => (
                  <SwiperSlide key={index}>
                    <div onClick={() => setVideo(video.video_id)}>
                      <Image
                        src={`https://img.youtube.com/vi/${video.video_id}/0.jpg`}
                        alt={video.name}
                        quality={100}
                        width={1200}
                        height={800}
                        className="w-full object-cover mb-4"
                      />
                      <p className="text-xs text-black line-clamp-3 text-ellipsis h-12">{video.name}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          )}
        </div>
        <div className="sticky hidden col-span-1 md:block top-20 h-fit border border-reviewBg border-solid rounded-lg p-4">
          <div className="w-2/3 p-2 mb-4 text-sm font-bold text-center text-white rounded-md bg-mooimom">TRENDING PRODUK</div>
          {focusProductData.data.length > 0 && (
            focusProductData.data.map((product, index) => (
              <div key={index} className="mb-3">
                <HorizontalProduct product={product} fullWidth={true} />
              </div>
            ))
          )}
        </div>
      </div>
      <MamapediaVideoList videos={videos} />
      <ShopAtMOOIMOM />
    </>
  )
}

export default MamapediaHome
